/**
 *  @class
 *  @function ModalDialog
 */
if (!customElements.get('modal-dialog')) {
  class ModalDialog extends HTMLElement {
    constructor() {
      super();

      this.age_verification = this.classList.contains('age-verification-modal');
      this.id = this.getAttribute('id');
      this.delay = parseInt(this.dataset.delay, 10) * 1000;
      this.popup = this.dataset.popup;
      this.section_id = this.dataset.sectionId;
      this.disabled = this.getAttribute('disabled') != undefined;
      this.button = this.querySelector('[id^="ModalClose-"]');

      this.button.addEventListener('click', this.hide.bind(this));

      if (!this.disabled) {
        this.addEventListener('keyup', (event) => {
          if (event.code.toUpperCase() === 'ESCAPE') {
            this.hide();
          }
        });
        this.addEventListener('click', (event) => {
          if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
        });
      }
      if (this.delay && this.delay > 0) {
        if (!this.getCookie()) {
          setTimeout(() => {
            this.show();
            this.button.addEventListener('click', this.setCookie.bind(this));
          }, this.delay);
        }
      }
      if (this.age_verification) {
        if (!this.getCookie()) {
          this.show();
        }
        this.button.addEventListener('click', this.setCookie.bind(this));
      }
      if (Shopify.designMode) {
        this.moved = true;
        document.addEventListener('shopify:section:select', (event) => {
          if (event.detail.sectionId === this.section_id) {
            this.show();
          }
        });
        document.addEventListener('shopify:section:deselect', (event) => {
          if (event.detail.sectionId === this.section_id) {
            this.hide();
          }
        });
      }
    }

    connectedCallback() {
      if (this.moved) return;
      this.moved = true;
      document.body.appendChild(this);
    }

    show(opener) {
      this.openedBy = opener;
      
      // Store the element that opened the modal for focus return
      this.previouslyFocusedElement = document.activeElement;
      
      document.body.classList.add('overflow-hidden');
      this.setAttribute('open', '');

      // Announce pop-up appearance to screen readers
      this.announcePopup();

      // Focus management for accessibility
      setTimeout(() => {
        const dialog = this.querySelector('[role="dialog"]');
        if (dialog) {
          dialog.focus();
          this.setupFocusTrap(dialog);
        }
      }, 100);
    }

    hide() {
      document.body.classList.remove('overflow-hidden');
      this.removeAttribute('open');
      this.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
      });
      this.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      this.querySelectorAll('video').forEach((video) => video.pause());

      // Return focus to the element that opened the modal
      if (this.previouslyFocusedElement && this.previouslyFocusedElement.focus) {
        this.previouslyFocusedElement.focus();
      }

      if (this.popup) {

      }
    }

    announcePopup() {
      // Create or get the live region for announcements
      let liveRegion = document.getElementById('modal-announcements');
      if (!liveRegion) {
        liveRegion = document.createElement('div');
        liveRegion.id = 'modal-announcements';
        liveRegion.setAttribute('aria-live', 'polite');
        liveRegion.setAttribute('aria-atomic', 'true');
        liveRegion.style.position = 'absolute';
        liveRegion.style.left = '-10000px';
        liveRegion.style.width = '1px';
        liveRegion.style.height = '1px';
        liveRegion.style.overflow = 'hidden';
        document.body.appendChild(liveRegion);
      }

      // Get the modal title or heading
      const heading = this.querySelector('.product-popup-modal--heading, h1, h2, h3, h4, h5, h6');
      const title = heading ? heading.textContent.trim() : 'Modal dialog';
      
      // Announce the pop-up
      let announcement = `Modal dialog opened: ${title}`;
      
      // Add specific context for different modal types
      if (this.age_verification) {
        announcement = `Age verification modal opened: ${title}`;
      } else if (this.popup) {
        announcement = `Pop-up window opened: ${title}`;
      }

      // Clear and announce
      liveRegion.textContent = '';
      setTimeout(() => {
        liveRegion.textContent = announcement;
      }, 100);
    }

    setupFocusTrap(dialog) {
      const focusableElements = dialog.querySelectorAll(
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      );
      
      if (focusableElements.length === 0) return;
      
      const firstFocusableElement = focusableElements[0];
      const lastFocusableElement = focusableElements[focusableElements.length - 1];
      
      // Handle Tab key to trap focus
      dialog.addEventListener('keydown', (e) => {
        if (e.key === 'Tab') {
          if (e.shiftKey) {
            // Shift + Tab
            if (document.activeElement === firstFocusableElement) {
              e.preventDefault();
              lastFocusableElement.focus();
            }
          } else {
            // Tab
            if (document.activeElement === lastFocusableElement) {
              e.preventDefault();
              firstFocusableElement.focus();
            }
          }
        }
      });
    }

    getCookie() {
      return window.localStorage.getItem(this.id);
    }
    setCookie() {
      window.localStorage.setItem(this.id, JSON.stringify(new Date()));
    }
  }
  customElements.define('modal-dialog', ModalDialog);
}
if (!customElements.get('modal-opener')) {
  class ModalOpener extends HTMLElement {
    constructor() {
      super();

      const button = this.querySelector('button');

      if (!button) return;
      button.addEventListener('click', () => {
        const modal = document.querySelector(this.getAttribute('data-modal'));
        if (!modal) return;
        modal.show(button);
        this.selectProductType(modal, button);
      });
    }

    selectProductType(modal, button) {
      const normalize = (value) => (value || '').trim().toLowerCase();
      const productType = normalize(button.getAttribute('data-product-type'));
      if (!productType) return;

      const items = modal.querySelectorAll('.product-popup-modal__content-info li');
      if (!items.length) return;

      let match = null;
      items.forEach((li) => {
        const liTypes = (li.getAttribute('data-product-type') || li.textContent || '')
          .trim()
          .toLowerCase()
          .split(',')
          .map(normalize);
        if (!match && liTypes.includes(productType)) match = li;
      });
      if (!match) return;

      items.forEach((li) => li.classList.remove('selected'));
      match.classList.add('selected');
      match.click();
    }
  }
  customElements.define('modal-opener', ModalOpener);
}